import React, { useEffect, useState } from "react";
import axios from "axios";
import consts from "../consts";
import { toast } from "react-toastify";
import { connect } from "react-redux";

function CreateEmpresa({ setLista, openEmpresa, setEmpresaOpen }) {
  const [values, setValues] = useState({
    cnpj: "",
    razaosocial: "",
    banco: "",
    fid: "",
    agencia: "",
    conta: "",
    codcontabil: "",
  });

  const changeValues = (e) => {
    const { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };

  const handleClear = () => {
    setValues({
      cnpj: "",
      razaosocial: "",
      banco: "",
      fid: "",
      agencia: "",
      conta: "",
      codcontabil: "",
    });
  };

  const handleConfirm = (data) => {
    const { cnpj, razaosocial, banco, fid, agencia, conta, codcontabil } = data;

    if (
      cnpj === "" ||
      razaosocial === "" ||
      banco === "" ||
      fid === "" ||
      agencia === "" ||
      conta === "" ||
      codcontabil === ""
    ) {
      return toast.warning("Preencha todos os campos para poder confirmar");
    }
    axios
      .post(`${consts.API_URL}/bancarios`, data)
      .then((resp) => {
        toast.success("Empresa criada com sucesso!");
        handleClear();
        setEmpresaOpen(false);

        axios
          .get(`${consts.API_URL}/bancariosNonRepeated`)
          .then((resp) => {
            setLista(resp.data);
          })
          .catch((e) => {
            console.log("erro", e);
          });
      })
      .catch((e) => {
        console.log("Erro detalhado:", e.response?.data);
        toast.error("Não foi possivel criar a Empresa");
      });
  };

  useEffect(() => {
    axios
      .get(`${consts.API_URL}/bancariosNonRepeated`)
      .then((resp) => setLista(resp.data));
  }, [setLista]);

  return (
    <div className="mb-3 mt-3">
      <div
        className={`fixed inset-0 flex justify-center items-center transition-colors 
                    ${openEmpresa ? "visible bg-black/20" : "invisible"}`}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className={`
                    bg-white rounded-xl shadow p-6 transition-all w-[350px] 
                    ${
                      openEmpresa
                        ? "scale-100 opacity-100"
                        : "scale-125 opacity-0"
                    }
                    `}
        >
          <button
            onClick={() => setEmpresaOpen(false)}
            className="absolute px-2 py-1 text-black rounded-full top-1 right-1"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <div className="flex flex-col w-full mr-4">
            <div className="flex flex-col gap-1">
              <span className="text-sm">Cnpj</span>
              <input
                type="text"
                name="cnpj"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.cnpj}
              />
              <span className="text-sm">Razão Social</span>
              <input
                type="text"
                name="razaosocial"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.razaosocial}
              />
              <span className="text-sm">Banco</span>
              <input
                type="text"
                name="banco"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.banco}
              />
              <span className="text-sm">Fid</span>
              <input
                type="text"
                name="fid"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.fid}
              />
              <span className="text-sm">Agência</span>
              <input
                type="text"
                name="agencia"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.agencia}
              />
              <span className="text-sm">Conta</span>
              <input
                type="text"
                name="conta"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.conta}
              />
              <span className="text-sm">Código Contábil</span>
              <input
                type="text"
                name="codcontabil"
                className="p-2 border b-gray-100 rounded-xl"
                onChange={changeValues}
                value={values.codcontabil}
              />

              <div className="flex justify-between w-full gap-2 mt-2">
                <button
                  className="px-4 py-2 font-semibold bg-gray-100 rounded-md hover:bg-gray-200"
                  onClick={() => handleClear()}
                >
                  Cancelar
                </button>
                <button
                  onClick={() => handleConfirm(values)}
                  className="px-4 py-2 font-semibold text-white bg-green-500 rounded-md hover:bg-green-600"
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps)(CreateEmpresa);
